import { stringify } from 'query-string';

import { Config, fetchJSON } from '@ratehub/base-ui';


async function fetchMortgageBreakagePenalty(params) {
    return fetchJSON(
        `${Config.MORTGAGE_PENALTY_BREAKAGE_API_URL}?${stringify(params)}`,
        'fetchMortgageBreakagePenalty',
    );
}

export default fetchMortgageBreakagePenalty;
